/* ================================================================
   LegBilligt — forhentning til Gavefinderen
   Gavefinderen henter selv "mest kobte" med det samme, sa den skal
   have netvaerket for sig selv i starten. Forst 1,5 sekund senere
   varmer vi de mest brugte alder/belob-kombinationer op, sa det
   forste rigtige klik ogsaa foles med det samme.
   Rent netvaerk — rorer ikke DOM'en.
   ================================================================ */
(function(){
  'use strict';

  var KOMBI = ['gave-6-8-100-199', 'gave-3-5-100-199', 'gave-9-12-200-299'];
  var UDSKUD = 1500;
  var gjort = false;

  function lille(src, b){
    if(!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + b;
  }

  function varm(handle){
    fetch('/collections/' + handle + '/products.json?limit=250&page=1')
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(d){
        (d.products || []).slice(0, 8).forEach(function(p){
          if(p.images && p.images[0]){
            var i = new Image();
            i.decoding = 'async';
            i.src = lille(p.images[0].src, 380);
          }
        });
      })
      .catch(function(){});
  }

  function start(){
    var el = document.querySelector('.lbgf');
    if(!el || gjort) return;
    gjort = true;
    function kald(){ setTimeout(function(){ KOMBI.forEach(varm); }, UDSKUD); }
    if(!('IntersectionObserver' in window)){ kald(); return; }
    var io = new IntersectionObserver(function(p){
      p.forEach(function(x){ if(x.isIntersecting){ io.disconnect(); kald(); } });
    }, { rootMargin: '800px 0px' });
    io.observe(el);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
